<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Vevői visszáru</span>
      <el-button
        style="float: right; margin-top: -5px;"
        type="success"
        size="small"
        @click="$router.replace('/sales/customer-return-orders/add')"
        icon="el-icon-plus"
        v-can="'customerreturnorder.create'"
      >
        Új vevői visszáru
      </el-button>
    </div>
    <div v-loading="loading" style="min-height: 81px;">
      <table-filter
        v-if="filterConfig"
        :config="filterConfig"
        action="customerReturnOrder/fetchAll"
      />
    </div>
    <customer-return-order-list/>
    <template v-if="$route.meta.showAddCustomerReturnOrderDialog">
      <customer-return-order-dialog
        type="add"
        :customer-return-order-id="$route.params.id"
      />
    </template>
    <template v-if="$route.meta.showUpdateCustomerReturnOrderDialog">
      <customer-return-order-dialog
        :customer-return-order-id="$route.params.id"
        type="update"
      />
    </template>
    <template v-if="$route.meta.showCustomerReturnOrderViewDialog">
      <customer-return-order-dialog
        :customer-return-order-id="$route.params.id"
        type="view"
      />
    </template>
  </el-card>
</template>

<script>
import customerReturnOrderList from '../../components/sales/customerReturnOrders/List';
import customerReturnOrderDialog from '../../components/sales/customerReturnOrders/Dialog';
import TableFilter from '../../components/TableFilter';

export default {
  components: {
    customerReturnOrderList,
    customerReturnOrderDialog,
    TableFilter,
  },
  data() {
    return {
      loading: false,
      filterConfig: null,
    };
  },
  async mounted() {
    this.loading = true;
    await this.setConfig();
    this.loading = false;
  },
  methods: {
    async setConfig() {
      this.filterConfig = [
        {
          type: 'text',
          name: 'receipt_number',
          label: 'Bizonylatszám',
          defaultSearch: true,
        },
        {
          type: 'text',
          name: 'cm_delivery_note_number',
          label: 'CM szlev száma',
        },
        {
          type: 'select',
          options: [
            {
              label: 'Rögzítve',
              status: 'recorded'
            },
            {
              label: 'Visszavéve',
              status: 'done'
            },
          ],
          name: 'status',
          label: 'Státusz',
          labelCallback: status => status.label,
          valueKey: 'status',
        },
        {
          type: 'select',
          options: [
            {
              label: 'Igen',
              value: 1
            },
            {
              label: 'Nem',
              value: 0
            },
          ],
          name: 'is_billable',
          label: 'Számlázandó',
          labelCallback: value => value.label,
          valueKey: 'value',
        },
        {
          type: 'text',
          name: 'invoice',
          label: 'Számlaszám',
        },
        {
          type: 'text',
          name: 'comment',
          label: 'Megjegyzés',
        },
        {
          type: 'select',
          options: [
            {
              label: 'Igen',
              hasInvoice: 1
            },
            {
              label: 'Nem',
              hasInvoice: 0
            },
          ],
          name: 'has_invoice',
          label: 'Van számla',
          labelCallback: status => status.label,
          valueKey: 'hasInvoice',
        },
        {
          type: 'remote',
          name: 'supplier_id',
          label: 'Szállító',
          labelCallback: partner => partner && `#${partner.id} ${partner.company.name}` || '',
          valueKey: 'id',
          remoteSearchParam: 'name',
          remoteAction: 'partner/search',
        },
      ];
    },
  },
};
</script>
